module.exports = __webpack_public_path__ + "img/w59b.cd8e856f.jpg";